import { Box, Typography } from "@mui/material";

import { uiNeutrals } from "../../../../constants/uiNeutrals";

const DISCOUNT_TYPE_OPTIONS = [
  { value: "", label: "All" },
  { value: "under_25", label: "Under RM25", priceBand: "under_25" },
  { value: "under_15", label: "Under RM15", priceBand: "under_15" },
  { value: "bxfy", label: "B1F1 / Buy X Free Y" },
  { value: "percentage", label: "% off" },
  { value: "amount", label: "RM off" },
  { value: "label", label: "Special" },
];

const selectedDiscountKey = (discountType, priceBand) => {
  if (priceBand === "under_15" || priceBand === "under_25") return priceBand;
  return discountType || "";
};

const DiscountTypeFilter = ({
  discountType = "",
  priceBand = "",
  onChange,
  isMobile = false,
}) => {
  const selected = selectedDiscountKey(discountType, priceBand);

  const handleSelect = (opt) => {
    const key = opt.priceBand || opt.value;
    if (selected === key) {
      onChange({ discountType: "", priceBand: "" });
      return;
    }
    if (opt.priceBand) {
      onChange({ discountType: "", priceBand: opt.priceBand });
      return;
    }
    onChange({ discountType: opt.value, priceBand: "" });
  };

  return (
    <Box sx={{ py: 1.5 }}>
      <Typography
        variant="subtitle2"
        sx={{
          mb: isMobile ? 1 : 1.25,
          color: "#000",
          fontSize: isMobile ? "16px" : undefined,
          fontWeight: isMobile ? 500 : undefined,
        }}
      >
        Discount
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 1,
          mb: isMobile ? 0 : 2,
        }}
      >
        {DISCOUNT_TYPE_OPTIONS.map((opt) => {
          const key = opt.priceBand || opt.value || "any";
          return (
          <Box
            key={key}
            onClick={() => handleSelect(opt)}
            sx={{
              cursor: "pointer",
              background: "#fff",
              color: "#000",
              borderRadius: "20px",
              px: 2,
              py: 1,
              minHeight: "36px",
              display: "inline-flex",
              alignItems: "center",
              fontSize: "14px",
              fontWeight: 500,
              whiteSpace: "nowrap",
              transition: "all 0.2s ease",
              border: selected === key ? "1px solid #000" : "1px solid #ddd",
              "&:hover": {
                bgcolor: uiNeutrals.surface,
              },
            }}
          >
            {opt.label}
          </Box>
        );
        })}
      </Box>
    </Box>
  );
};

export default DiscountTypeFilter;
